import type { LabelEntity, StoreControl } from 'commons';

export type CommentModel = {
  identifier: string;
  owner: string;
  comment: string;
  startTime: string;
  endTime: string;
  showInLane: boolean;
  mappedChannels: string[];
  mappedLabels: string[];
};

export function withLocalCommentVisibility(comment: CommentModel, visibility: boolean): CommentModel {
  return {
    ...comment,
    showInLane: visibility,
  };
}

export class ExplodedCommentModel {
  /**
   *  identifier
   */
  identifier!: string;
  /**
   *  owner
   */
  owner!: string;
  /**
   *  comment
   */
  comment!: string;
  /**
   *
   */
  startTime!: string;
  /**
   *
   */
  endTime!: string;
  /**
   *
   */
  showInLane!: boolean;
  /**
   *
   */
  mappedChannels!: (StoreControl | undefined)[];
  /**
   *
   */
  mappedLabels: LabelEntity[] = [];
  /**
   *
   * @param _comment
   */
  constructor(public readonly _comment: CommentModel) {
    if (_comment) {
      Object.assign(this, _comment);
    }
  }
  /**
   *
   * @param controls
   */
  public exploadControls(controls: StoreControl[]) {
    this.mappedChannels = this._comment.mappedChannels?.map((channel) => controls.find((control) => control.id === channel)).filter((d) => d !== undefined);

    return this;
  }
  /**
   *
   * @param labels
   * @returns
   */
  public exploadLabels(labels: LabelEntity[]) {
    this.mappedLabels = this._comment.mappedLabels?.map((label) => labels.find((l) => l.identifier === label)).filter((d) => d !== undefined);
    return this;
  }
}
